import { render } from "./SpecialOrderDetails.vue?vue&type=template&id=3b4e70b8&scoped=true"
import script from "./SpecialOrderDetails.vue?vue&type=script&lang=js"
export * from "./SpecialOrderDetails.vue?vue&type=script&lang=js"

import "./SpecialOrderDetails.vue?vue&type=style&index=0&id=3b4e70b8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4e70b8"]])

export default __exports__